import { render, staticRenderFns } from "./TaskDia.vue?vue&type=template&id=0be8393b&scoped=true&"
import script from "./TaskDia.vue?vue&type=script&lang=js&"
export * from "./TaskDia.vue?vue&type=script&lang=js&"
import style0 from "./TaskDia.vue?vue&type=style&index=0&id=0be8393b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be8393b",
  null
  
)

export default component.exports